import { AloftPrice } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import {
  selectBelowGradeFullBathCost,
  selectZipOnlyBelowGradeFullBathCost,
} from './costSelectors/selectBelowGradeFullBathCost.ts';
import {
  selectBelowGradeHalfBathCost,
  selectZipOnlyBelowGradeHalfBathCost,
} from './costSelectors/selectBelowGradeHalfBathCost.ts';
import {
  selectFinishedBasementAreaCost,
  selectZipOnlyFinishedBasementAreaCost,
} from './costSelectors/selectFinishedBasementAreaCost.ts';
import {
  selectTotalBasementAreaCost,
  selectZipOnlyBasementAreaCost,
} from './costSelectors/selectTotalBasementAreaCost.ts';

const calculateTotalBasementCost = (
  totalBasementAreaCost: ReturnType<typeof selectTotalBasementAreaCost> | undefined,
  finishedBasementAreaCost: ReturnType<typeof selectFinishedBasementAreaCost> | undefined,
  belowGradeFullBathCost: ReturnType<typeof selectBelowGradeFullBathCost> | undefined,
  belowGradeHalfBathCost: ReturnType<typeof selectBelowGradeHalfBathCost> | undefined,
) => {
  return AloftPrice.add(
    totalBasementAreaCost,
    finishedBasementAreaCost,
    belowGradeFullBathCost,
    belowGradeHalfBathCost,
  );
};

export const selectTotalBasementCost = createSelector(
  [
    selectTotalBasementAreaCost,
    selectFinishedBasementAreaCost,
    selectBelowGradeFullBathCost,
    selectBelowGradeHalfBathCost,
  ],
  calculateTotalBasementCost,
);

export const selectZipOnlyBasementCost = createSelector(
  [
    selectZipOnlyBasementAreaCost,
    selectZipOnlyFinishedBasementAreaCost,
    selectZipOnlyBelowGradeFullBathCost,
    selectZipOnlyBelowGradeHalfBathCost,
  ],
  calculateTotalBasementCost,
);
